import React from 'react'
import CustomSlider from 'components/Slider'
import useConfig from 'store/ConfigProvider'
import {
  DesktopHeaderCategoriesItem,
  BadgeNew,
} from 'style/CategoryList/CategoryList.style'
import categoryUrl from 'helpers/categoryUrl'
import styled from 'styled-components'

const SingleSlideContainer = styled.div`
  border-radius: 50%;
  background-color: #f2f4f5;

  & a {
    padding: 13px;
  }
`

const MobileCategorySlider = props => {
  const { topCategories } = useConfig()

  return (
    <div className={'brands-slider'} style={{ marginTop: 10 }}>
      <CustomSlider
        style={{ display: 'flex !important', justifyContent: 'space-between' }}
        settings={{
          dots: false,
          swipeToSlide: true,
          slidesToShow: 5,
          autoplay: true,
          autoplaySpeed: 1500,
        }}
      >
        {topCategories.map(cat => (
          <SingleSlideContainer>
            <DesktopHeaderCategoriesItem href={categoryUrl(cat.url)}>
              {cat.title === 'Citrus Shop' ? (
                <div style={{ position: 'relative', display: 'flex' }}>
                  <img src={cat.icon} alt="category icon" />

                  <BadgeNew isMobile={false}>new</BadgeNew>
                </div>
              ) : (
                <img src={cat.icon} alt="category icon" />
              )}
            </DesktopHeaderCategoriesItem>
          </SingleSlideContainer>
        ))}
      </CustomSlider>
    </div>
  )
}

export default MobileCategorySlider
